import { memo, PropsWithChildren } from 'react';
import { useCarouselContext } from '../carousel.context';

type SlideProps = {
  index: number;
  style?: React.CSSProperties;
  className?: string;
};

export const Slide = memo(
  ({ index, style, className, children }: PropsWithChildren<SlideProps>) => {
    const { total } = useCarouselContext();

    return (
      <div
        data-carousel-slide={index}
        style={{
          position: 'relative',
          width: `${100 / total}%`,
          flexShrink: 0,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          ...style,
        }}
        className={className}
      >
        {children}
      </div>
    );
  }
);

Slide.displayName = 'Carousel.Slide';
